module.exports = __webpack_public_path__ + "static/img/1.8ae78b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/admin/1.png
// module id = v9go
// module chunks = 0